import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {FormGroup} from '@material-ui/core';
import {RemoveRedEye as RemoveRedEyeIcon, Delete as DeleteIcon} from '@material-ui/icons';
import {isEmpty} from 'lodash/lang';
import ReactSelect from 'react-select';
import {
  withKluwellTableWrapper,
  KluwellTableCore,
  SortingManager,
  DeletionConfirmBox,
  ArchivedOnlyTableFilter,
} from 'components/common';
import {formatRole, getViewableRolesToInvite} from 'utils/common';
import * as permissions from 'utils/permissions';

class ExtraFilters extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    myRole: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selected) {
    const {onChange} = this.props;
    const selectedRole = isEmpty(selected) ? undefined : selected.value;
    if (selectedRole) {
      onChange([
        {
          name: 'role',
          value: selectedRole,
        },
        {
          name: 'queryRoleMode',
          value: 'strict',
        },
      ]);
    } else {
      onChange([
        {
          name: 'role',
          value: undefined,
        },
        {
          name: 'queryRoleMode',
          value: undefined,
        },
      ]);
    }
  }

  render() {
    const {
      myRole,
      values: {role, archivedOnly},
      onChange,
    } = this.props;
    return (
      <div className="extra-table-filters">
        <FormGroup>
          <ReactSelect
            name="role"
            value={role}
            placeholder="User Role"
            onChange={this.handleChange}
            options={getViewableRolesToInvite(myRole)}
            autoBlur={true}
            closeOnSelect={true}
          />
        </FormGroup>
        {permissions.isSchoolCoordinatorOrTeacher(myRole) && (
          <ArchivedOnlyTableFilter archivedOnly={archivedOnly} onChange={onChange} />
        )}
      </div>
    );
  }
}

const buildUserRecords = (users) => {
  const sortedIds = users.sortedIds || [];
  return isEmpty(sortedIds)
    ? []
    : sortedIds.map((userId) => {
        const user = users[userId];
        return {
          id: userId,
          firstName: user.firstName,
          lastName: user.lastName,
          username: user.username,
          email: user.email,
          role: user.role,
          actions: '',
        };
      });
};

const buildUserSettings = () => ({
  firstName: {
    fieldText: 'First Name',
    sortable: true,
  },
  lastName: {
    fieldText: 'Last Name',
    sortable: true,
  },
  username: {
    fieldText: 'Username',
    sortable: true,
  },
  email: {
    fieldText: 'Email',
    sortable: true,
  },
  role: {
    fieldText: 'Role',
    formatData: (cell) => formatRole(cell),
  },
  actions: {
    fieldText: 'Actions',
    formatData: (cell, row, restProps) => (
      <span className="table-actions">
        <Link to={`/users/${row.id}`} title="view">
          <RemoveRedEyeIcon />
        </Link>
        {restProps.canDeleteRow && (
          <DeleteIcon className="cursor-pointer" onClick={() => restProps.showDeletionConfirmBox(row)} />
        )}
      </span>
    ),
  },
});

class UserTableCore extends React.Component {
  static propTypes = {
    recordPages: PropTypes.object.isRequired,
    onSortableFieldClick: PropTypes.func.isRequired,
    onDeleteActionClick: PropTypes.func,
    deletionAlertText: PropTypes.string,
    me: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      userToRemove: {},
    };
    this.showDeletionConfirmBox = this.showDeletionConfirmBox.bind(this);
    this.sortingManager = new SortingManager();
  }

  showDeletionConfirmBox(user) {
    this.setState(
      {
        userToRemove: user,
      },
      () => {
        ReactDOM.findDOMNode(this.deletionConfirmBoxRef)
          .querySelector('.btn-show-confirm')
          .click();
      },
    );
  }

  render() {
    const {recordPages, onSortableFieldClick, onDeleteActionClick, deletionAlertText, hiddenFields, me} = this.props;
    const users = recordPages[recordPages.currentPage] || {};
    const records = buildUserRecords(users);
    const settings = buildUserSettings();
    return (
      <React.Fragment>
        {onDeleteActionClick && (
          <DeletionConfirmBox
            ref={(ref) => (this.deletionConfirmBoxRef = ref)}
            alertText={deletionAlertText}
            itemName="user"
            deleteAction={() => onDeleteActionClick(this.state.userToRemove)}
            DeleteButton="span"
          />
        )}
        <KluwellTableCore
          {...{
            records,
            settings,
            sortingManager: this.sortingManager,
            onSortableFieldClick,
            hiddenFields,
            canDeleteRow: !!onDeleteActionClick && permissions.isKluwellAdmin(me.role),
            showDeletionConfirmBox: this.showDeletionConfirmBox,
            me,
          }}
        />
      </React.Fragment>
    );
  }
}

export default withKluwellTableWrapper(UserTableCore, ExtraFilters);
